import React, { useState, useEffect } from "react";
import Content from "../homePage/Components/Content";
import { useParams } from "react-router";
import "./ThyroidLp.css";
import Featured from "../homePage/Components/Featured";
import FAQforhomepage from "../homePage/FAQforhomepage";
import { WhyChooseUs } from "../packageDetailsPage/Newlp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Lp7form from "./Lp7form";
import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import LpForm from "../packageDetailsPage/LpForm";

import { getCall } from "../../Redux/Actions";

import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, NavLink, useLocation } from "react-router-dom";
import Apointment from "../homePage/Components/Apointment";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";
// import LpFormNew from "../packageDetailsPage/LpFormNew";

function ThyroidLp() {
  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [footerTel, setTelNum] = useState("");
  const [leadSource, setleadSource] = useState("Ecommerce");
  const [lpImage, setlpImage] = useState(false);
  const [disable, setDisable] = useState(true);
  const [tenSecPass, settenSecPass] = useState(false);
  const [showPopUp, setshowPopUp] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [successBtn, setSuccessBtn] = useState(false);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  const params = useParams();

  const [displayCall, setDisplaycall] = useState(true);
  //useLocation
  const location = useLocation();
  //url
  var url = `https://redcliffelabs.com${location?.pathname}/bottom${location?.search}`;
  const dispatch = useDispatch();
  //scrooll top
  const scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number*");
      return false;
    } else {
      return true;
    }
  };
  //handel submit
  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: leadSource,
        city: "",
        url,
      };

      setUserNumber("");
      setUserName("");
      setSuccessBtn(true);
      setTimeout(() => {
        setSuccessBtn(false);
      }, 2000);
      setPhoneEror("");

      dispatch(getCall(body));
    }
  };

  //validation on submit button
  useEffect(() => {
    if (userName == "" || userNumber == "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [userName, userNumber]);
  //handel Username
  const handelUserName = (e) => {
    setUserName(e.target.value);
    setshowPopUp(false);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setshowPopUp(false);
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  useEffect(() => {
    const mybutton = document.getElementById("getCall");
    window.onscroll = function() {
      scrollFunction();
      // console.log("af");
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 0 ||
        document.documentElement.scrollTop > 0
      ) {
        mybutton.style.display = "flex";
      } else {
        mybutton.style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  const FAQ = [
    {
      id: 1,
      title: "Where can I get a thyroid test done in Delhi?",
      desc:
        "When you are looking to get the thyroid test in Delhi, then it is recommended to pick renowned services like Redcliffe Labs. Reason being is that we have been in the diagnostic service for years and have integrated the team of professionals having years of experience. Your tests will be performed under the best and advanced technology. Test reports are delivered on time and accuracy is ensured by following the strict NABL guidelines.",
    },
    {
      id: 2,
      title: " What are the normal thyroid test results?",
      desc:
        "The normal range for thyroid test results for an adult is around 0.40-4.50 mIU/mL. It helps in identifying the thyroid disorders if there are any. ",
    },
    {
      id: 3,
      title: " When & why one gets their thyroid tested? ",
      desc:
        "The thyroid tests are used for checking whether it is working fine or not. It also helps in finding the cause for problems like hypothyroidism. It should be done when you are facing signs like tiredness, always feeling hot or cold, changes in appearance, weight changes etc.",
    },
    {
      id: 4,
      title: "Is fasting required for Thyroid Test?",
      desc:
        "No, there is no requirement for fasting while you plan to get this test done. ",
    },
  ];

  return (
    <>
      <div className="thyroidLP">
        <div className="thyroidContainer flex-prop">
          <div className="LeftThyroid">
            <div className="imageContainer">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f83aac08-d8c0-4673-97d2-bcf25218688e.webp"
                alt="banner"
                width="100%"
              />
              <div className="packDetail d-flex-lp">
                <div className="details_pack">
                  <span>One-Stop Diagnostic Service Provider</span>
                </div>
                <div className="details_pack">
                  <span>3500+ Routine & Specialized Tests</span>
                </div>
                <div className="details_pack">
                  <span>100% Accurate Results*</span>
                </div>
                <div className="details_pack">
                  <span>100+ Cities served across the country</span>
                </div>
              </div>
            </div>
          </div>
          <div className="RightThyroid">
            <div className="baseDivLp">
              {/* <div className="subHeader">
                <h2>Book your test</h2>
                <p>Select from our range of 3500+ tests</p>
              </div> 
Contact Us
care@redcliffelabs.com
898 898 8585*/}

              <LpForm
                buttonId={"LpTop"}
                formId={"LpForm"}
                focusInput={setDisplaycall}
                push={true}
                onBlur={() => setDisable(true)}
                isLp={true}
                lpNumber="898 898 8585"
                lpThyroid={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="testDetails thyroidContainer">
        <div className="upperSection_thyroid">
          <div className="thyroidDivContainer">
            <h3>TEST DETAILS</h3>
            <span className="fastDetails">
              Fasting Is Required Before The Test
            </span>
          </div>

          <p>
            When you are looking to get the thyroid test , then it is
            recommended to pick renowned services like Redcliffe Labs. Reason
            being is that we have been in the diagnostic service for years and
            have integrated the team of professionals having years of
            experience. Your tests will be performed under the best and advanced
            technology. Test reports are delivered on time and accuracy is
            ensured by following the strict NABL guidelines.
          </p>
        </div>
        <div className="lowerSection">
          <div className="NewlpDivRow ">
            <div className="lpcards">
              <div className="card__imglp">
                <LazyLoadImage
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                  }
                  alt={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                  }
                  delayTime="100"
                  width="100%"
                />
              </div>
              <div className="card__contentlp">
                <span className="mainHeading">Get Reports in</span>
                <span className="redHeading">24 HOURS </span>
              </div>
            </div>

            <div className="lpcards">
              <div className="card__imglp">
                <LazyLoadImage
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                  }
                  alt={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                  }
                  delayTime="100"
                  width="100%"
                />
              </div>
              <div className="card__contentlp">
                <span className="mainHeading"> Patient Instruction</span>
                <span className="redHeading">8-10 HR FASTING</span>
              </div>
            </div>

            {/**sample information */}

            {/**Home collection packDetail.home_collection */}

            <div className="lpcards">
              <div className="card__imglp">
                <LazyLoadImage
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d961f67f-996d-44ee-85c3-2fc51ab25ca3.svg"
                  alt="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d961f67f-996d-44ee-85c3-2fc51ab25ca3.svg"
                  delayTime="100"
                  width="100%"
                />
              </div>
              <div className="card__contentlp">
                <span className="mainHeading">Home Collection</span>
                <span className="redHeading">Available</span>
              </div>
            </div>

            <div className="lpcards">
              <div className="card__imglp">
                <LazyLoadImage
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                  }
                  alt={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                  }
                  delayTime="100"
                  width="100%"
                />
              </div>
              <div className="card__contentlp">
                <span className="mainHeading">Age Group</span>
                <span className="redHeading">5-99 years</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="thyroidDiv">
        <WhyChooseUs throid={true} />

        <Apointment
          parentPath="lpPage"
          img={
            "https://staticcdn.redcliffelabs.com/media/gallary-file/None/b0268e52-8763-461d-9ea2-60e273ff46d3.png"
          }
          butname="BOOK TEST NOW"
        />
        <Featured />
        <Content title="Testimonials" Ispackage={false} isTestimonial={true} />
        <FAQforhomepage faq={FAQ} />
      </div>

      {/***FIXED FOOTER */}
      <div className="disclaimerLp">
        <p>
          Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation and
          prevention of Misuse) Act, 1994", our labs strictly does not determine
          the sex of the fetus.
        </p>
      </div>
      <div className="Lpfooter">
        <div className="lpfooter__content">
          <form id="LpBottomForm" onSubmit={handelSubmit}>
            <div className="nameInput ">
              Name
              <input
                type="text"
                onChange={handelUserName}
                className={nameError ? "colorRed" : ""}
                placeholder={nameError ? nameError : "Enter Name"}
                value={nameError ? () => setUserName("") : userName}
              ></input>
            </div>
            <div className="phoneInput">
              Phone Number
              <input
                type="text"
                className={phoneError ? "colorRed" : ""}
                placeholder={phoneError ? phoneError : "Enter Phone Number"}
                value={phoneError ? () => setUserName("") : userNumber}
                onChange={handelPhoneChange}
                required
              ></input>
            </div>

            {successBtn ? (
              <div className="submitButton__lpfooter">
                <button
                  disabled="disabled"
                  className="btnSuccess"
                  type="submit"
                >
                  Success
                </button>
              </div>
            ) : (
              <div className="submitButton__lpfooter">
                <button
                  id={isMobile ? "MobileLpbottom" : "Lpbottom"}
                  disabled={nameError || disable ? "disabled" : null}
                  className={nameError || disable ? "disabled" : null}
                  type="submit"
                >
                  Book Now
                </button>
              </div>
            )}
          </form>
        </div>
        {displayCall ? (
          <div className="footer_lpgetcall">
            <div className="footerBtn" id="getCall">
              <button id=" " onClick={scrollTop}>
                Get A Call Now
              </button>
            </div>
          </div>
        ) : null}

        {/* <button id="MobFotterButton" onClick={scrollTop}>
            Book Now
          </button> */}
      </div>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open1}
        onClose={onCloseModal1}
        center
      >
        <Popup setOpen={setOpen1} />
      </Modal>
    </>
  );
}

export default {
  component: ThyroidLp,
};
